import i18n from '@/translation'
import RolesHelper from '@/helpers/Roles'

const { t } = i18n.global

const AdminMenuConfig = [
    {
        heading: 'Dashboard',
        routeName: 'admin-dashboard',
        fontIcon: 'fa-solid fa-layer-group me-2',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    },
    {
        heading: 'Campaigns',
        routeName: 'admin-campaign',
        fontIcon: 'fa-solid fa-compass me-2',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    },
    {
        heading: 'Prelanders',
        routeName: 'admin-prelander',
        fontIcon: 'fa-solid fa-file me-2',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    },
    {
        heading: 'Offers',
        routeName: 'admin-offer',
        fontIcon: 'fa-solid fa-list-check me-2',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    },

    {
        heading: 'Orders',
        routeName: 'admin-order',
        fontIcon: 'fa-solid fa-bars-staggered me-2',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    },
    {
        heading: 'Demands',
        routeName: 'admin-demand',
        fontIcon: 'fa-solid fa-map me-2',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    },
    {
        heading: 'Smart Cpa',
        routeName: 'admin-smartcpa',
        fontIcon: 'fa-solid fa-puzzle-piece me-2',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    },
    {
        heading: 'Categories',
        routeName: 'admin-category',
        fontIcon: 'fa-solid fa-layer-group me-2',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    },

    {
        heading: '---------',
        routeName: 'admin-dashboard',
        fontIcon: '',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
        separator: true,
    },
    {
        heading: 'Advertisers',
        routeName: 'admin-advertiser',
        fontIcon: 'fa-solid fa-building me-2',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    },
    {
        heading: 'Publishers',
        routeName: 'admin-publisher',
        fontIcon: 'fa-regular fa-building me-2',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    },
    // {
    //     heading: 'Affiliates',
    //     routeName: 'admin-affiliate',
    //     fontIcon: 'fa-solid fa-address-book me-2',
    //     roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin],
    // },
    {
        heading: 'Users',
        routeName: 'admin-user',
        fontIcon: 'fa-solid fa-users me-2',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    },

    {
        heading: '---------',
        routeName: 'admin-dashboard',
        fontIcon: '',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
        separator: true,
    },
    {
        heading: 'Settings',
        routeName: '',
        fontIcon: 'fa-solid fa-gears me-2',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
        subMenu: [
            {
                heading: 'Site',
                routeName: 'admin-settings-site',
                fontIcon: 'fa-solid fa-link ms-3 me-2',
                roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
            },
            {
                heading: 'Filters',
                routeName: 'admin-settings-filter',
                fontIcon: 'fa-solid fa-filter ms-3 me-2',
                roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
            },
            {
                heading: 'Parameters',
                routeName: 'admin-settings-parameters',
                fontIcon: 'fa-solid fa-gear ms-3 me-2',
                roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
            },
            {
                heading: 'Migration issues',
                routeName: 'admin-settings-migration-issues',
                fontIcon: 'fa-solid fa-triangle-exclamation ms-3 me-2',
                roles: [RolesHelper.Roles.Admin],
            },
            // {
            //     heading: 'API Endpoints',
            //     routeName: 'admin-settings-api-endpoints',
            //     fontIcon: 'fa-solid fa-code ms-3 me-2',
            //     roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
            // },
            {
                heading: 'Connectors',
                routeName: 'admin-settings-connector',
                fontIcon: 'fa-solid fa-circle-nodes ms-3 me-2',
                roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
            },
            {
                heading: 'Plans',
                routeName: 'admin-commission-plans',
                fontIcon: 'fa-solid fa-file-invoice ms-3 me-2',
                roles: [RolesHelper.Roles.Admin],
            },
            {
                heading: 'Events',
                routeName: 'admin-commission-events',
                fontIcon: 'fa-solid fa-chart-line ms-3 me-2',
                roles: [RolesHelper.Roles.Admin],
            },
            {
                heading: 'Devalidations',
                routeName: 'admin-commission-devalidations',
                fontIcon: 'fa-solid fa-file-import ms-3 me-2',
                roles: [RolesHelper.Roles.Admin],
            },
            // {
            //     heading: 'Commissions',
            //     routeName: '',
            //     fontIcon: 'fa-solid fa-coins ms-3 me-2',
            //     roles: [RolesHelper.Roles.Admin],
            //     subMenu: [

            //     ],
            // },
        ]
    },

    // {
    //     heading: '---------',
    //     routeName: 'admin-dashboard',
    //     fontIcon: '',
    //     roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    //     separator: true,
    // },
    // {
    //     heading: 'WIP// Leads',
    //     routeName: 'admin-lead',
    //     fontIcon: 'fa-solid fa-database me-2',
    //     roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    // },
    {
        heading: 'WIP// Stats',
        routeName: 'admin-stat',
        fontIcon: 'fa-solid fa-chart-line me-2',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    },
    {
        heading: 'Stats V2',
        routeName: 'admin-stat-v2',
        fontIcon: 'fa-solid fa-chart-bar me-2',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    },
    {
        heading: 'Live Stats',
        routeName: 'admin-stat-live',
        fontIcon: 'fa-solid fa-bolt me-2',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    },
    {
        heading: 'Delivery Stats',
        routeName: 'admin-stat-delivery',
        fontIcon: 'fa-solid fa-truck me-2',
        roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    },

    // {
    //     heading: 'SubM with image',
    //     routeName: 'admin-user',
    //     fontIcon: 'fa-solid fa-users me-2',
    //     image: 'logo-without-brand.png',
    //     roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    //     subMenu: [
    //         {
    //             heading: 'List',
    //             routeName: 'admin-user-list',
    //             fontIcon: 'fa-solid fa-users ms-3 me-2',
    //             roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    //         },
    //         {
    //             heading: 'Edit',
    //             routeName: 'admin-user-edit',
    //             fontIcon: 'fa-solid fa-users ms-3 me-2',
    //             roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    //         },
    //         {
    //             heading: 'Delete',
    //             routeName: 'admin-user-delete',
    //             image: 'logo-without-brand.png',
    //             fontIcon: 'fa-solid fa-users ms-3 me-2',
    //             roles: [RolesHelper.Roles.Manager, RolesHelper.Roles.Moderator, RolesHelper.Roles.Admin, RolesHelper.Roles.Advertiser, RolesHelper.Roles.Publisher],
    //         },
    //     ],
    // },
]

export default AdminMenuConfig
